import { ISuccessState } from '../../../types'

export function success(state: ISuccessState, action: any): ISuccessState {
  if (typeof state === 'undefined') {
    return { message: '', updatedAt: Date.now() }
  }
  //Assume all success actions have a success field
  if (action.type.match(/SUCCESS_MESSAGE/)) {
    return Object.assign({}, state, {
      message: action.payload,
      updatedAt: Date.now()
    })
  }
  return state
}



// WEBPACK FOOTER //
// ./src/state/reducers/success/index.ts